<script setup>
import { useIdle, watchThrottled } from '@vueuse/core';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const IDLE_TIMEOUT = 30 * 60 * 1000;
const ACTIVITY_KEY = 'lastActivity';

const { idle, lastActive, reset } = useIdle(IDLE_TIMEOUT);

localStorage.setItem(ACTIVITY_KEY, Date.now());
watchThrottled(lastActive, (ts) => localStorage.setItem(ACTIVITY_KEY, ts), { throttle: 30000 });

const homepage = import.meta.env.VITE_DRUPAL_URL;
const timeout = import.meta.env.VITE_TIMEOUT;

watch(idle, (idleValue) => {
  if (idleValue && timeout == 'true') {
    // Another tab was active recently: keep the session alive.
    const lastShared = Number(localStorage.getItem(ACTIVITY_KEY)) || 0;
    if (Date.now() - lastShared < IDLE_TIMEOUT) {
      reset();
      return;
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const isSso = user?.is_sso === true;
    localStorage.clear();

    if (isSso) {
      // SSO: native logout, IdP flow untouched (no inactivity message).
      window.location.href = homepage + '/' + locale.value + '/user/logout';
    } else {
      // Regular account: pass the flag so the home page shows the message.
      const destination = encodeURIComponent('/' + locale.value + '?timeout=1');
      window.location.href = homepage + '/' + locale.value + '/user/logout?destination=' + destination;
    }
  }
})
</script>

<template>
</template>
